module.exports = __webpack_public_path__ + "static/media/ShareClass.63b7fb51.svg";